import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Dashboard from './Dashboard'
import AppDisplay from './AppDisplay'
import AppFeatures from './AppFeatures'
import AppAuthorization from './AppAuthorization'
import AppDistribution from './AppDistribution'
import AppOverview from './AppOverview'

const Apps = props => (
	<Switch>
		<Route exact path="/apps" component={Dashboard} />
		<Route path="/apps/:appId/distribution" component={AppDistribution} />
		<Route path="/apps/:appId/display" component={AppDisplay} />
		<Route path="/apps/:appId/features" component={AppFeatures} />
		<Route path="/apps/:appId/authorization" component={AppAuthorization} />
		<Route path="/apps/:appId/" component={AppOverview} />
	</Switch>
)

export default Apps



// WEBPACK FOOTER //
// ./src/views/Apps/Apps.js